PegasusTemplate.ButtonController = Em.ObjectController.extend();
